import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const journeyRoutes = [
  {
    id: 'journey-idle',
    trackingName: 'Journey Idle',
    path: '/',
    element: null,
  },
] as const satisfies JourneyRoute[]
